import { render, staticRenderFns } from "./Smiley.vue?vue&type=template&id=30649d23&scoped=true"
import script from "./Smiley.vue?vue&type=script&lang=ts"
export * from "./Smiley.vue?vue&type=script&lang=ts"
import style0 from "./Smiley.vue?vue&type=style&index=0&id=30649d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30649d23",
  null
  
)

export default component.exports